var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.statusIcon)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"left":"","title":_vm.statusText,"color":_vm.statusColor}},on),[_vm._v(_vm._s(_vm.statusIcon))])]}}],null,false,2119807580)},[_c('span',[_vm._v(_vm._s(_vm.statusText))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }